import App from '../components/app/app'
import Contact from '../components/contact/contact'
import Header from '../components/header/header'
import React from 'react'
import Services from '../components/services/services'
import Slider from '../components/slider'
import Subscription from '../components/subscription/subscription'
import { graphql } from 'gatsby'
import navigation from '../navigation/index'
import styles from './index.module.css'

export const indexQuery = graphql`
  query Index {
    authorImage: file(relativePath: { eq: "author.jpg" }) {
      childImageSharp {
        fixed(width: 200, height: 183) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    slideImageOne: file(relativePath: { eq: "slideOne.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1280) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    slideImageTwo: file(relativePath: { eq: "slideTwo.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1280) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Index = (props) => {
  const data = {
    slideImageOne: props.data.slideImageOne.childImageSharp.fluid,
    slideImageTwo: props.data.slideImageTwo.childImageSharp.fluid,
    contactImage: props.data.authorImage.childImageSharp.fixed,
  }

  return (
    <App navigation={navigation}>
      <div className={styles.children}>
        <div id={'top'}>
          <Header navigation={navigation} />
        </div>
        <div className={styles.hero}>
          <Slider
            slides={[
              data.slideImageOne,
              data.slideImageTwo,
            ]}
          />
        </div>
        <div id={'services'} className={styles.services}>
          <Services />
        </div>
        <div id={'subscription'} className={styles.subscription}>
          <Subscription />
        </div>
        <div id={'contact'} className={styles.contact}>
          <Contact image={data.contactImage} />
        </div>
      </div>
    </App>
  )
}

export default Index
